import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

// A custom withRouter HOC to provide navigate and location as props
const withRouter = (Component) => {
  return function WithRouter(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    return <Component {...props} navigate={navigate} location={location} params={params} />;
  };
};

export default withRouter;
